import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Row, Col, Container, Form } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import Field from '../../../components/Entity/Field'
import ModalPicker from '../../../components/Modals/ModalPicker'
import { ApiManager } from '../../../core/api-manager';
import { Utils } from '../../../core/utils';
import { settings } from '../../settings';



export default function DGSH_customer_invoices({ data, setData, selectedRows, setSelectedRows, refreshData }) {

    const navigate = useNavigate();

    // Movement scope modal state
    const [showMovementScopeModal, setShowMovementScopeModal] = useState(false);
    const [movementScope, setMovementScope] = useState(null);
    const [movementScopeList, setMovementScopeList] = useState(null);
    const [unloadLoading, setUnloadLoading] = useState(false);
    const [arrayError, setArrayError] = useState([]);
    const [unloadResult, setUnloadResult] = useState(null); // null | { success: true } | { success: false }
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [syncSdiLoading, setSyncSdiLoading] = useState(false);

    useEffect(() => {
        // Load movement scopes and default to "VENDITA" if present
        async function initMovementScopes() {
            const sorting = { field: 'id', order: 'asc' };
            const resMov = await DataManager.getItems('movement_scope', 1, 100, sorting);
            if (resMov?.success === 1) {
                setMovementScopeList(resMov.body);
                const vendita = resMov.body.find((item) => item.name === 'VENDITA');
                if (vendita) setMovementScope(vendita.id);
            }
        }
        initMovementScopes();
    }, []);

    function openMovementScopeModal() {
        setShowMovementScopeModal(true);
    }

    function closeMovementScopeModal() {
        setShowMovementScopeModal(false);
    }

    function closeResultModal() {
        setShowErrorModal(false);
        setUnloadResult(null);
        setArrayError([]);
        if (typeof refreshData === 'function') {
            refreshData();
        }
    }



    async function unloadAll() {
        var sorting = {
            'field': 'id',
            'order': 'DESC'
        }
        var constraints = [
            { fieldName: "id", type: "in", value: selectedRows.toString() }
        ]

        // Ensure movementScope is selected before proceeding
        if (movementScope === null) {
            openMovementScopeModal();
            return;
        }
        setUnloadLoading(true);
        try {
            const errors = [];
            setArrayError([]);
            var s = await DataManager.searchItems('customer_invoices', 1, 100, sorting, '', [], constraints);
            if (s.success === 1) {
                const checkStatus = s.body.every(item => item.status?.value === "0_PENDING");
                console.log(checkStatus, s.body)
                if (checkStatus) {
                    for (let i = 0; i < s.body.length; i++) {
                        let fatturaHasErrors = false;
                        var sortingCO = {
                            'field': 'id',
                            'order': 'DESC'
                        }
                        var constraintsCO = [
                            { fieldName: "internalCode", type: "in", value: s.body[i].orderNumber }
                        ]
                        var resCO = await DataManager.searchItemsSimple('customer_order', 1, 100, sortingCO, '', [], constraintsCO)
                        if (resCO.success === 1) {
                            if (resCO.body[0].idWarehouseOutlet?.no_mrp === 0 && resCO.body[0].idWarehouseOutlet?.internal === 1) {
                                //SCARICO DA CENTRALE
                                for (let a = 0; a < s.body[i].rows.length; a++) {
                                    var qta = parseInt(s.body[i].rows[a].quantity)
                                    if (qta !== 0) {
                                        var resItemModel = await DataManager.getItemSimple('item_model', s.body[i].rows[a].idItemModel);
                                        const im = resItemModel.body[0];

                                        //scarico da magazzino di default
                                        const dataUnload = {
                                            idItem: im.id,
                                            idMovementScope: parseInt(movementScope),
                                            quantity: parseInt(qta),
                                            idWarehouse: im.idWarehouse ? im.idWarehouse.id : null,
                                            numberDocument: s.body[i].internalCode,
                                            notes: '',
                                            checkQuantity: true
                                        }
                                        var resUnload = await ApiManager.sendAuthenticatedRequest('/custom/warehouse_unload', dataUnload);
                                        if (resUnload.success === 1) {
                                            toast.success('Quantità scaricata con successo', { theme: 'colored' });
                                            var status = { value: '10_UNLOADED' }
                                            const dataUpdate = {
                                                warehouseItemModel: im.idWarehouse ? im.idWarehouse.name : "",
                                                status: status,
                                                fulfilledQuantity: parseInt(qta),
                                                quantityUnloaded: parseInt(qta)
                                            }
                                            var resUpdate = await DataManager.updateItem('customer_invoices_rows', dataUpdate, s.body[i].rows[a].id);
                                            if (resUpdate.success === 1) {
                                                toast.success('Riga aggiornata con successo', { theme: 'colored' });
                                            } else {
                                                toast.error("Errore nell'aggiornare la riga", { theme: 'colored' });
                                                fatturaHasErrors = true;
                                                errors.push({ id: im.id, message: "Errore nell'aggiornare la riga", code: im.code, name: im.name })
                                            }
                                        }
                                        else {
                                            fatturaHasErrors = true;
                                            errors.push({ id: im.id, message: resUnload.message, code: im.code, name: im.name })
                                        }
                                    }
                                }
                            } else {
                                //SCARICO DA ALTRI --> senza controllo quantity
                                for (let a = 0; a < s.body[i].rows.length; a++) {
                                    var qta = parseInt(s.body[i].rows[a].quantity)
                                    if (qta !== 0) {
                                        var resItemModel = await DataManager.getItemSimple('item_model', s.body[i].rows[a].idItemModel);
                                        const im = resItemModel.body[0];

                                        //scarico da magazzino di default
                                        const dataUnload = {
                                            idItem: im.id,
                                            idMovementScope: parseInt(movementScope),
                                            quantity: parseInt(qta),
                                            idWarehouse: resCO.body[0].idWarehouseOutlet?.id,
                                            numberDocument: s.body[i].internalCode,
                                            notes: '',
                                            checkQuantity: false
                                        }
                                        var resUnload = await ApiManager.sendAuthenticatedRequest('/custom/warehouse_unload', dataUnload);
                                        if (resUnload.success === 1) {
                                            toast.success('Quantità scaricata con successo', { theme: 'colored' });
                                            var status = { value: '10_UNLOADED' }
                                            const dataUpdate = {
                                                warehouseItemModel: resCO.body[0].idWarehouseOutlet?.name,
                                                status: status,
                                                fulfilledQuantity: parseInt(qta),
                                                quantityUnloaded: parseInt(qta)
                                            }
                                            var resUpdate = await DataManager.updateItem('customer_invoices_rows', dataUpdate, s.body[i].rows[a].id);
                                            if (resUpdate.success === 1) {
                                                toast.success('Riga aggiornata con successo', { theme: 'colored' });
                                            } else {
                                                toast.error("Errore nell'aggiornare la riga", { theme: 'colored' });
                                                fatturaHasErrors = true;
                                                errors.push({ id: im.id, message: "Errore nell'aggiornare la riga", code: im.code, name: im.name })
                                            }
                                        }
                                        else {
                                            fatturaHasErrors = true;
                                            errors.push({ id: im.id, message: resUnload.message, code: im.code, name: im.name })
                                        }
                                    }
                                }
                            }
                        } else {
                            fatturaHasErrors = true;
                            errors.push({ id: s.body[i].id, message: 'Ordine cliente non trovato', code: s.body[i].orderNumber, name: 'Fattura ' + s.body[i].internalCode })
                        }

                        // Se nessun errore per questo fattura, aggiorna stato a 20_UNLOADED
                        if (!fatturaHasErrors) {
                            const updatefatturaData = { status: { value: '20_UNLOADED' } };
                            const upd = await DataManager.updateItem('customer_invoices', updatefatturaData, s.body[i].id);
                            if (upd.success !== 1) {
                                fatturaHasErrors = true;
                                errors.push({ id: s.body[i].id, message: 'Impossibile aggiornare lo stato della fattura', code: s.body[i].internalCode, name: 'Fattura' })
                            }
                        }
                    }
                    if (errors.length > 0) {
                        setArrayError(errors);
                        setUnloadResult({ success: false });
                        setShowErrorModal(true);
                    } else {
                        setArrayError([]);
                        setUnloadResult({ success: true });
                        setShowErrorModal(true);
                    }
                } else {
                    toast.error("Selezionare solo fatture con stato uguale a IN ATTESA.", { theme: 'colored' })
                }


            }
        } finally {
            setUnloadLoading(false);
        }
    }






    async function syncAllSdiStatuses() {
        if (syncSdiLoading) return;
        setSyncSdiLoading(true);
        try {
            const res = await ApiManager.sendAuthenticatedRequest('/custom/sync_all_invoice_statuses', {});
            if (res.success === 1) {
                const msg = `Controllate: ${res.checked || 0}, Aggiornate: ${res.updated || 0}`;
                toast.success(msg, { theme: 'colored' });
                if (res.updated > 0 && typeof refreshData === 'function') {
                    refreshData();
                }
            } else {
                toast.error(res.message || 'Errore sincronizzazione stati SDI', { theme: 'colored' });
            }
        } catch (err) {
            toast.error('Errore: ' + err.message, { theme: 'colored' });
        } finally {
            setSyncSdiLoading(false);
        }
    }

    return (
        <>
            <Container>
                <Row className="gap-2">
                    <Button className='my-1' variant='success' size='sm' disabled={unloadLoading} onClick={() => openMovementScopeModal()} style={{ width: 'auto' }}>
                        {unloadLoading ? (<><Spinner animation='border' size='sm' className='me-2' />Scarico in corso...</>) : 'Scarica tutto'}
                    </Button>
                    {settings.fatturazione && (
                        <Button className='my-1' variant='outline-info' size='sm' disabled={syncSdiLoading} onClick={syncAllSdiStatuses} style={{ width: 'auto' }}>
                            {syncSdiLoading ? (<><Spinner animation='border' size='sm' className='me-2' />Aggiornamento...</>) : (<><FontAwesomeIcon icon='rotate' className='me-1' />Aggiorna stati SDI</>)}
                        </Button>
                    )}
                </Row>
            </Container>

            {/* Modal: Esito scarico */}
            <Modal show={showErrorModal} onHide={closeResultModal} centered size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>{arrayError && arrayError.length > 0 ? 'Errori durante lo scarico' : 'Scarico completato'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {arrayError && arrayError.length > 0 ? (
                        <Table striped bordered hover size='sm' className='mb-0'>
                            <thead>
                                <tr>
                                    <th style={{ width: '15%' }}>Codice</th>
                                    <th style={{ width: '35%' }}>Nome</th>
                                    <th>Messaggio</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arrayError.map((e) => (
                                    <tr key={e.id}>
                                        <td>{e.code}</td>
                                        <td>{e.name}</td>
                                        <td>{e.message}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <Alert variant='success' className='mb-0'>Scarico completato con successo.</Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='primary' onClick={closeResultModal}>Chiudi</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal: Select Movement Scope before unloading */}
            <Modal show={showMovementScopeModal} onHide={closeMovementScopeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Seleziona causale movimentazione</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {movementScopeList && movementScopeList.length > 0 ? (
                        <Form>
                            <Form.Label>Causale</Form.Label>
                            <Form.Select onChange={(e) => setMovementScope(e.target.value)} value={movementScope || ''}>
                                <option value='' disabled>Seleziona una causale</option>
                                {movementScopeList.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </Form.Select>
                        </Form>
                    ) : (
                        <Alert variant='info' className='mb-0'>Caricamento causali movimentazione...</Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={closeMovementScopeModal} disabled={unloadLoading}>Annulla</Button>
                    <Button
                        variant='primary'
                        disabled={movementScope === null || unloadLoading}
                        onClick={async () => {
                            if (movementScope === null) return;
                            closeMovementScopeModal();
                            await unloadAll();
                        }}
                    >
                        {unloadLoading ? (<><Spinner animation='border' size='sm' className='me-2' />In corso...</>) : 'Conferma e scarica'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};
